import { render } from "./DisableModulePopup.vue?vue&type=template&id=dc38d4a6&scoped=true&lang=pug"
import script from "./DisableModulePopup.vue?vue&type=script&lang=js"
export * from "./DisableModulePopup.vue?vue&type=script&lang=js"

import "./DisableModulePopup.vue?vue&type=style&index=0&id=dc38d4a6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc38d4a6"]])

export default __exports__